export const DRAFTING_FE_BASE_URL = `${import.meta.env.VITE_EUREKA_URI}/agentic`;

export const CHECKING_FE_BASE_URL = `${import.meta.env.VITE_EUREKA_URI}/drafting`;

export const IS_BREAK_JUMP = localStorage.getItem('eureka_drafting_break_jump') === 'true';

export const IS_IN_IFRAME = window.self !== window.top;
